/**
 * Jobs Financial Dashboard Route
 *
 * Route: /_auth/jobs/
 *
 * Displays comprehensive financial view of all jobs including:
 * - Budget vs Actuals
 * - Revenue and Costs
 * - Current and Projected Margins
 * - Filterable by client, status, period
 */

import { createFileRoute } from '@tanstack/react-router';
import JobsFinancialPage from '@/app/jobs/page';

export const Route = createFileRoute('/_auth/jobs/')({
  component: JobsFinancialPage,
});
